import DraggableSelectedItem from 'components/SelectedItem/DraggableSelectedItem';
import { UserRoles, IItemForGetShortDishInfo } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import React from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DnDList.module.scss';

interface IDnDList {
	setSuggestedDishes: (value: string[]) => void;
	removeSuggestedDish: (value: string) => void;
	selectedSuggestedDishes: string[];
	fetchedSuggestedDishes: IItemForGetShortDishInfo[];
}

const DnDList: React.FC<IDnDList> = ({
	selectedSuggestedDishes,
	fetchedSuggestedDishes,
	setSuggestedDishes,
	removeSuggestedDish,
}) => {
	const hasChangePositionAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	const handleDragEnd = (result: DropResult) => {
		if (!selectedSuggestedDishes.length || !result.destination) {
			return null;
		}
		const items = selectedSuggestedDishes;
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		setSuggestedDishes(items);
	};

	return (
		<DragDropContext onDragEnd={handleDragEnd}>
			<Droppable droppableId="suggestedDishList">
				{(provided) => (
					<div className={style.suggestedDishList} ref={provided.innerRef} {...provided.droppableProps}>
						{selectedSuggestedDishes.map((el, index) => {
							const dish = fetchedSuggestedDishes.find((fetched) => fetched.id === el);

							return (
								<Draggable key={el} draggableId={el} index={index}>
									{(provided) => (
										<DraggableSelectedItem
											draggableInnerRef={provided.innerRef}
											provided={provided}
											positionNumber={index + 1}
											label={dish?.name || ''}
											onDelete={() => removeSuggestedDish(el)}
											hasDragAccess={hasChangePositionAccess}
											additionalContent={
												<>
													{dish?.externalId && (
														<ChunkOfTextWithCopying
															text={dish.externalId}
															className={style.externalId}
														/>
													)}
												</>
											}
										/>
									)}
								</Draggable>
							);
						})}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default React.memo(DnDList);
